import { Injectable } from "@angular/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { map } from "rxjs/operators";
import { Configuracoes } from "../entities/configuracoes";
import { Usuario } from "../entities/usuario";
import * as CryptoJS from 'crypto-js';
declare var $: any;

type Banner = {
  id: number;
  link: string;
  image: string;
  imageMobile: string;
  ordem: number;
};

@Injectable({
  providedIn: "root",
})
export class InitProvider {
  public usuario: Usuario;
  public filiais: any = [];
  public banners: Banner[] | undefined;
  public inicializaPedido: boolean;
  public usaTipoPedido: boolean
  public usaFilialEstoque: boolean

  constructor(public http: Http) {}

  mensagemCriptografada: string = '597DC9FE0955F641F2B3994DAFF6A339'; // Aqui você colocaria a mensagem criptografada
  chave: string = 'urnae245vjr5eosd'; 

  decryptData(encryptedData, secretKey) {
    try {
        const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData);
        const iv = CryptoJS.lib.WordArray.create(encryptedDataBytes.words.slice(0, 4), 16);
        const encryptedMessage = CryptoJS.lib.WordArray.create(encryptedDataBytes.words.slice(4), encryptedDataBytes.sigBytes - 16);
        const key = CryptoJS.enc.Utf8.parse(secretKey);
        const decrypted = CryptoJS.AES.decrypt({ ciphertext: encryptedMessage }, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        console.error("Decryption failed:", e);
        return "";
    }
}

 decryptAndShow(encrypted) {
    const secretKey = this.chave
    const encryptedData = encrypted

    if (encryptedData === "" || secretKey === "") {
        console.error("Encrypted data or secret key is empty.");
        return;
    }

    const decryptedData = this.decryptData(encryptedData, secretKey);
    return decryptedData;
}
  async load() {
    return await new Promise((resolve) => {
      this.http
        .get("appconfig-v2.json", this.getHttpOptions())
        .pipe(map((config) => {
          if(config.json().prod){
            console.log("1")
            return JSON.parse(this.decryptAndShow(config.json().dados))
          } else {
            return config.json()
          }
        }))
        .subscribe((config) => {
          console.log(config)
          Configuracoes.patchAppConfig(config);
          resolve(
            new Promise((resolve) => {
              this.http
              .get(Configuracoes.API + "principal", this.getHttpOptions())
              .pipe(map((principal) => {
                console.log(principal)
                  if(Configuracoes.cypher){
                    return JSON.parse(this.decryptAndShow(principal.json().dados))
                  }
                  return principal.json()
                }))
                .subscribe(async (principal) => {
                 if(Configuracoes.API_BANNERS !== null)
                    {
                      await new Promise((resolve) => {
                        this.http
                          .get(Configuracoes.API_BANNERS, this.getHttpOptions())
                          .pipe(map((resp) => resp.json() as Banner[]))
                          .subscribe(async (banners) => {
                            principal.configuracao.sliderPrincipal = banners;
                            resolve(true);
                          });
                      });
                    }
                  console.log(principal)
                  Configuracoes.SITE = principal.configuracao;
                  this.filiais = principal.filiais.filter((f) => f.ativo);
                  this.inicializaPedido = principal.configuracao.inicia_pedido_selecionado;
                  this.usaTipoPedido = principal.configuracao.usa_tipo_pagamento
                  this.usaFilialEstoque = principal.configuracao.usa_filial_estoque
                  if (this.hasToken()) {
                    resolve(
                      new Promise((resolve) => {
                        this.http
                          .get(
                            Configuracoes.API + "usuario",
                            this.getHttpOptionsLogin()
                          )
                          .pipe(map((resp) => resp.json()))
                          .subscribe(
                            (resp) => {
                              this.usuario = resp;
                              if (Configuracoes.SITE.appendHeadAfterLogin) {
                                $("head").append(
                                  Configuracoes.SITE.appendHeadAfterLogin
                                );
                              }
                              resolve(true);
                            },
                            (error) => {
                              window.localStorage.removeItem("token");
                              window.localStorage.removeItem("tipoUsuario");
                              window.localStorage.removeItem("pedido");
                              window.location.href = "/login";
                            }
                          );
                      })
                    );
                  } else {
                    resolve(true);
                  }
                },(principal) => 
                  {
                    resolve(true);
                  });
            })
          );
        });
    });
  }

  hasToken() {
    return window.localStorage.getItem("token") != null;
  }

  getToken() {
    return window.localStorage.getItem("token");
  }

   async getLocation(){
    await new Promise((resolve) => {
      this.http
        .get('https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location', this.getHttpOptions())
        .pipe(map((resp) => resp.json()))
        .subscribe(async (resp) => {
          resolve(true);
        }, () => console.log('erro'));
    });
  }

  getHttpOptionsLogin() {
    var header = new Headers({
      "Content-Type": "application/json",
      Branch: Configuracoes.API_BRANCH,
    });
    if (this.hasToken()) {
      header.set("Authorization", "Bearer " + this.getToken());
    }
    return new RequestOptions({
      headers: header,
    });
  }

  getHttpOptions() {
    var header = new Headers({
      "Content-Type": "application/json",
      Branch: Configuracoes.API_BRANCH,
    });
    if (this.hasToken()) {
      header.set("Authorization", "Bearer " + this.getToken());
    }
    return new RequestOptions({
      headers: header,
    });
  }
}
